// FIXME: PB-6225 - Remove Route.BrightPodcast after the migration

export enum Route {
    Homepage = '',

    // News
    Advertorial = 'advertorial',
    AdvertorialArticle = 'advertorial/[...slug]',
    News = 'news',
    Article = 'news/[...slug]',
    ArticlePreview = 'news/preview/[...slug]',
    AudioArticle = 'audio/[...slug]',
    CategoryNews = 'category-news/[...slug]',
    Podcast = 'category-news/podcast',
    PremiumArticle = 'premium/[...slug]',
    BrightPodcast = 'category-news/bright-podcast',
    RecentNews = 'news/recent',
    TransferNews = 'news/transfernews',
    TransferRumors = 'transferrumors',
    VideosArticle = 'videos/[slug]/[articleSlug]',
    VideoArticle = 'video/[...slug]',
    VideosArticlePreview = 'videos/preview/[...slug]',
    VideoCategory = 'videos/[slug]',
    VideoOverview = 'videos',

    // Tag Overview
    BrandOverview = 'brands',
    CarOverview = 'cars',
    ClubOverview = 'clubs',
    CompetitionOverview = 'competitions',
    DossierOverview = 'dossiers',
    EventOverview = 'events',
    LocationOverview = 'locations',
    OrganizationOverview = 'organizations',
    PersonOverview = 'people',
    PlayerOverview = 'players',
    TopicOverview = 'topics',

    Premium = 'premium',
    BrightPlusPlus = 'plusplus',

    // Tag Detail
    Betting = 'dossiers/wedden',

    Car = 'cars/[...slug]',
    LicensePlate = 'license-plate/[tag]',

    Club = 'clubs/[tag]',
    ClubMatches = 'clubs/[tag]/matches',
    ClubSelection = 'clubs/[tag]/selection',
    ClubNews = 'clubs/[tag]/news',

    Competition = 'competitions/[tag]',
    CompetitionTabOrSeason = 'competitions/[tag]/[...slug]',

    Dossier = 'dossiers/[...slug]',
    Event = 'events/[...slug]',
    Location = 'locations/[...slug]',
    Organization = 'organizations/[...slug]',
    Person = 'people/[...slug]',
    Topic = 'topics/[...slug]',

    // Player Detail
    PlayerInfo = 'players/[tag]/info',
    PlayerCareer = 'players/[tag]/career',
    PlayerNews = 'players/[tag]/news',
    Player = 'players/[tag]', // Keep BELOW more specific routes

    // Sport Data
    Match = 'livescores/[date]/[slug]',
    MatchByID = 'livescores/match/[matchID]',
    MatchInfo = 'livescores/[date]/[slug]/match',
    MatchSetup = 'livescores/[date]/[slug]/setup',
    MatchStats = 'livescores/[date]/[slug]/stats',
    MatchSummary = 'livescores/[date]/[slug]/summary',
    MatchNews = 'livescores/[date]/[slug]/news',
    MatchOverviewDay = 'livescores/[date]',
    MatchOverview = 'livescores',
    MySquad = 'my-squad',
    MatchPrediction = 'match-prediction/[optaID]',

    // Profile
    ForgotPassword = 'password-forgot/[[...slug]]',
    Notifications = 'profile/notifications',
    MySubscription = 'profile/mySubscription',
    Profile = 'profile',
    Settings = 'profile/settings',
    MyPxr = 'profile/myPxr',
    Bookmarks = 'profile/bookmarks',

    // Subscribe
    SubscribeSwitch = 'subscribe-switch',
    SubscribeSuccess = 'subscribe-success/[[...slug]]',
    SubscribeFailure = 'subscribe-failure/[[...slug]]',
    Subscribe = 'subscribe/[[...slug]]',

    // Supertokens
    VerifyEmail = 'secure/verify-email',
    Signin = 'secure/signin',
    PasswordReset = 'secure/password-reset',
    AttemptRefresh = 'secure/attempt-refresh',
    Signout = 'secure/signout',

    // Sitemaps
    SitemapIndex = 'sitemap.xml',
    AuthorSitemap = 'sitemap-authors.xml',
    MatchesSitemap = 'sitemap-matches.xml',
    NavigationSitemap = 'sitemap-navigation.xml',
    GoogleNewsSitemap = 'sitemap-google-news.xml',
    SegmentedWeekNewsSitemap = 'sitemap/news/[year]/w/[week]',
    SegmentedQuarterNewsSitemap = 'sitemap/news/[year]/q/[quarter]',
    SegmentedVideosSitemap = 'sitemap/videos/[year]/[month]',
    SegmentedTagSitemap = 'sitemap/[tagType]/[from]/[to]',
    TagSitemap = 'sitemap/[tagType]',

    // RSS
    RssFeedOverview = 'page/rss-feeds',
    FeedMedia = 'feed/media.xml',
    FeedNews = 'feed/news.xml',

    // Spots
    Spots = 'spots',
    UploadSpots = 'upload-spots',
    UploadSpotsSuccess = 'upload-spots-success',
    Spot = 'spot/[...slug]',

    // Others
    Author = 'author/[slug]',
    AdsTxt = 'ads.txt',
    Browserconfig = 'browserconfig.xml',
    Comments = 'comments/[...slug].tsx',
    VideoPlayer = 'video-player/[...slug].tsx',
    Contact = 'page/contact',
    Error = '_error',
    Liveness = 'liveness',
    Readiness = 'readiness',
    Manifest = 'manifest.json',
    OneSignalSDKWorker = 'OneSignalSDKWorker.js',
    Page = 'page/[...slug]',
    PlayerRating = 'player-rating/[date]/[slug]',
    Preview = 'preview',
    Robots = 'robots.txt',
    Search = 'search',
    User = 'user/[slug]',
    UserMatchPredictionsCompetition = 'user-match-predictions/[competitionID]',
    UserMatchPredictionsCompetitionSeason = 'user-match-predictions/[competitionID]/[season]',
    UserMatchPredictionsCompetitionSeasonDate = 'user-match-predictions/[competitionID]/[season]/[date]',
    UserMatchPredictionsCompetitionScoreboard = 'user-match-predictions/[competitionID]/scoreboard',
    UserMatchPredictionsScoreboard = 'user-match-predictions/scoreboard',
    WellKnownAndroid = '.well-known/assetlinks.json',
    WellKnownIOS = '.well-known/apple-app-site-association',
}
